import style from '@style/error.scss';



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/styles/error.js